<template>
  <section id="features" class="section section--soft">
    <div class="container">
      <div class="section-head">
        <span class="eyebrow">产品功能</span>
        <h2 class="section-title">一个软件，覆盖三大内容电商平台</h2>
        <p class="section-sub">
          模拟人工完成达人筛选、在线邀约、商品报名与进度跟进，把重复劳动交给软件，
          已服务全国抖店、快手小店与小红书商家。
        </p>
      </div>

      <!-- 分段控件：切换平台 -->
      <div class="seg" role="tablist" aria-label="平台切换">
        <button
          v-for="p in platforms"
          :key="p.key"
          class="seg-item"
          :class="{ 'is-active': active === p.key }"
          role="tab"
          :aria-selected="active === p.key"
          @click="active = p.key"
        >
          <span class="seg-dot" :style="{ background: p.color }"></span>
          {{ p.label }}
        </button>
      </div>

      <div v-for="p in platforms" :key="p.key" v-show="active === p.key" class="platform">
        <p class="platform-desc">{{ p.desc }}</p>

        <el-carousel
          :key="p.key"
          class="shots"
          :interval="4500"
          height="380px"
          :autoplay="true"
          indicator-position="outside"
          arrow="hover"
          @change="onShotChange"
        >
          <el-carousel-item v-for="(src, i) in p.shots" :key="i">
            <img
              :src="require(`@/assets/img/${p.dir}/${i + 1}.jpg`)" 
              :alt="p.label + '功能截图 ' + (i + 1)"
              class="shot-img"
            />
          </el-carousel-item>
        </el-carousel>

        <div class="detail-grid">
          <div class="detail-copy">
            <div class="detail-tabs">
              <button
                v-for="(d, i) in p.details"
                :key="i"
                class="detail-tab"
                :class="{ 'is-active': idx[p.key] === i }"
                @click="idx[p.key] = i"
              >{{ d.title }}</button>
            </div>

            <transition name="swap" mode="out-in">
              <div class="detail-body" :key="idx[p.key]">
                <h3 class="detail-title">{{ p.details[idx[p.key]].title }}</h3>
                <ul class="detail-list">
                  <li v-for="(pt, i) in p.details[idx[p.key]].points" :key="i">{{ pt }}</li>
                </ul>
              </div>
            </transition>
          </div>

          <figure class="detail-figure">
            <el-image
              class="detail-img"
              :src="require(`@/assets/img/${p.dir}1/${idx[p.key] + 1}.png`)"
              :preview-src-list="p.detailShots"
              :initial-index="idx[p.key]"
              fit="contain"
              :preview-teleported="true"
              :alt="p.label + p.details[idx[p.key]].title + '详情图'"
            />
            <figcaption>点击图片可放大查看</figcaption>
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FeatureSection",
  data() {
    return {
      active: "douyin",
      idx: { douyin: 0, kuaishou: 0, xiaohongshu: 0 },
      platforms: [
        {
          key: "douyin",
          label: "抖音",
          color: "#fe2c55",
          dir: "douyin",
          desc: "针对抖店商家，依赖于谷歌浏览器，做模拟人工的自动化操作，解决人工的繁琐耗时低效操作问题。",
          shots: 6,
          detailShots: [1, 2, 3, 4, 5, 6].map((i) =>
            require(`@/assets/img/douyin1/${i}.png`)
          ),
          details: [
            {
              title: "抖音智能推荐",
              points: [
                "进入【智能推荐】页面，支持每周达人推荐和按商品找达人",
                "一键自动在线邀约，可查看达人的多维度信息（带货数据、手机号、微信号、简介，自动解析手机号、微信号，达人管理里的达人 uid）",
                "自动勾选商品报名达人活动",
                "支持自动跳过已沟通过的达人、已报名招商的达人",
                "支持自动滑块验证",
                "支持速度设置"
              ]
            },
            {
              title: "抖音达人广场",
              points: [
                "进入【达人广场】页面，支持筛选达人",
                "一键自动在线邀约，可查看达人的多维度信息（带货数据、手机号、微信号、简介，自动解析手机号、微信号，达人管理里的达人 uid）",
                "自动勾选商品报名达人活动",
                "支持自动跳过已沟通过的达人、已报名招商的达人",
                "支持自动滑块验证",
                "支持速度设置"
              ]
            },
            {
              title: "同行合作参考",
              points: [
                "进入【同行合作参考】页面，支持筛选达人，查看同行店铺合作达人",
                "一键自动在线邀约，可查看达人的多维度信息（带货数据、手机号、微信号、简介，自动解析手机号、微信号，达人管理里的达人 uid）",
                "自动勾选商品报名达人活动",
                "支持自动跳过已沟通过的达人、已报名招商的达人",
                "支持自动滑块验证",
                "支持速度设置"
              ]
            },
            {
              title: "达人排行榜",
              points: [
                "进入【达人排行榜】页面，支持筛选达人，日榜、周榜、月榜",
                "一键自动在线邀约，可查看达人的多维度信息（带货数据、手机号、微信号、简介，自动解析手机号、微信号，达人管理里的达人 uid）",
                "自动勾选商品报名达人活动",
                "支持自动跳过已沟通过的达人、已报名招商的达人",
                "支持自动滑块验证",
                "支持速度设置"
              ]
            },
            {
              title: "抖音团长服务广场",
              points: ["进入【团长服务广场】页面，自动在线联系沟通，可以自定义话术"]
            },
            {
              title: "抖音团长招商",
              points: ["进入【团长招商】页面，支持筛选团长、佣金和服务费", "自动报名活动"]
            }
          ]
        },
        {
          key: "kuaishou",
          label: "快手",
          color: "#ff5000",
          dir: "kuaishou",
          desc: "针对快手小店商家，依赖于谷歌浏览器，做模拟人工的自动化操作，解决人工的繁琐耗时低效操作问题。",
          shots: 4,
          detailShots: [1, 2, 3, 4].map((i) =>
            require(`@/assets/img/kuaishou1/${i}.png`)
          ),
          details: [
            {
              title: "快手智能推荐",
              points: [
                "进入【智能推荐】页面，支持每周达人推荐和按商品找达人",
                "一键自动发送邀请、在线沟通，可查看达人的多维度信息（带货数据、手机号、微信号、简介，自动解析手机号、微信号，达人管理里的达人 uid）",
                "自动勾选商品报名达人活动",
                "支持自动跳过已沟通过的达人、已报名招商的达人",
                "支持自动滑块验证",
                "支持速度设置"
              ]
            },
            {
              title: "快手达人广场",
              points: [
                "进入【达人广场】页面，支持筛选达人",
                "一键自动发送邀请、在线沟通，可查看达人的多维度信息（带货数据、手机号、微信号、简介，自动解析手机号、微信号）",
                "自动勾选商品报名达人活动",
                "支持自动跳过已沟通过的达人、已报名招商的达人",
                "支持自动滑块验证",
                "支持速度设置"
              ]
            },
            {
              title: "快手达人排行榜",
              points: [
                "进入【达人排行榜】页面，支持筛选达人，带货销售榜、带货成长榜、单场峰值榜",
                "一键自动发送邀请、在线沟通，可查看达人的多维度信息（带货数据、手机号、微信号、简介，自动解析手机号、微信号，达人管理里的达人 uid）",
                "自动勾选商品报名达人活动",
                "支持自动跳过已沟通过的达人、已报名招商的达人",
                "支持自动滑块验证",
                "支持速度设置"
              ]
            },
            {
              title: "快手团长招商",
              points: [
                "进入【团长招商】页面，支持筛选团长、佣金、销售额、团长等级",
                "一键自动在线沟通，可以自定义话术"
              ]
            }
          ]
        },
        {
          key: "xiaohongshu",
          label: "小红书",
          color: "#ff2442",
          dir: "xiaohongshu",
          desc: "针对小红书小店商家，依赖于谷歌浏览器，做模拟人工的自动化操作，解决人工的繁琐耗时低效操作问题。",
          shots: 3,
          detailShots: [1, 2, 3].map((i) =>
            require(`@/assets/img/xiaohongshu1/${i}.png`)
          ),
          details: [
            {
              title: "小红书蒲公英-看榜单",
              points: [
                "进入【看榜单】页面，支持筛选买手",
                "一键自动邀约，可查看买手的多维度信息（带货数据、手机号、微信号、简介，自动解析手机号、微信号）",
                "自动勾选商品报名买手活动",
                "支持自动跳过已沟通过的买手、已报名招商的买手",
                "支持自动滑块验证",
                "支持速度设置"
              ]
            },
            {
              title: "小红书蒲公英-找买手",
              points: [
                "进入【买手】页面，支持筛选买手",
                "一键自动邀约，可查看买手的多维度信息（带货数据、手机号、微信号、简介，自动解析手机号、微信号）",
                "自动勾选商品报名买手活动",
                "支持自动跳过已沟通过的买手、已报名招商的买手",
                "支持自动滑块验证",
                "支持速度设置"
              ]
            },
            {
              title: "小红书蒲公英-看同行",
              points: [
                "进入【看同行】页面，支持筛选同行店铺，查看已合作的买手",
                "一键自动邀约，可查看买手的多维度信息（带货数据、手机号、微信号、简介，自动解析手机号、微信号）",
                "自动勾选商品报名买手活动",
                "支持自动跳过已沟通过的买手、已报名招商的买手",
                "支持自动滑块验证",
                "支持速度设置"
              ]
            }
          ]
        }
      ]
    };
  },
  methods: {
    onShotChange(i) {
      // 轮播与右侧详情联动
      if (this.idx[this.active] !== i && i < this.platforms.find(p => p.key === this.active).details.length) {
        this.idx[this.active] = i;
      }
    }
  }
};
</script>

<style scoped>
/* ---------- 分段控件 ---------- */
.seg {
  display: inline-flex;
  gap: 4px;
  padding: 5px;
  margin: 0 auto 32px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--r-full);
  box-shadow: var(--shadow-sm);
}

.seg {
  display: flex;
  width: fit-content;
}

.seg-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 42px;
  padding: 0 26px;
  border-radius: var(--r-full);
  color: var(--text-2);
  font-size: 15px;
  font-weight: 600;
  transition: color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease;
}

.seg-item:hover {
  color: var(--text-1);
}

.seg-item.is-active {
  color: var(--brand-dark);
  background: var(--brand-soft);
  box-shadow: inset 0 0 0 1px rgba(31, 162, 240, 0.24);
}

.seg-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.platform-desc {
  max-width: 860px;
  margin: 0 auto 28px;
  color: var(--text-2);
  font-size: 15px;
  line-height: 1.75;
  text-align: center;
}

/* ---------- 截图轮播 ---------- */
.shots {
  max-width: 1040px;
  margin: 0 auto 40px;
  --el-carousel-indicator-width: 22px;
  --el-carousel-indicator-height: 4px;
}

.shots :deep(.el-carousel__container) {
  border-radius: var(--r-lg);
}

.shots :deep(.el-carousel__item) {
  border-radius: var(--r-lg);
  overflow: hidden;
  border: 1px solid var(--border);
  background: #fff;
}

.shot-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.shots :deep(.el-carousel__indicator button) {
  background: rgba(17, 24, 39, 0.18);
  border-radius: var(--r-full);
  opacity: 1;
}

.shots :deep(.el-carousel__indicator.is-active button) {
  background: var(--brand);
}

.shots :deep(.el-carousel__arrow) {
  background: rgba(17, 24, 39, 0.42);
  backdrop-filter: blur(6px);
}

/* ---------- 详情两栏 ---------- */
.detail-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);
  gap: 32px;
  align-items: start;
}

.detail-copy {
  padding: 28px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--r-lg);
  box-shadow: var(--shadow-sm);
}

.detail-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding-bottom: 18px;
  margin-bottom: 20px;
  border-bottom: 1px solid var(--border);
}

.detail-tab {
  padding: 6px 13px;
  border-radius: var(--r-full);
  color: var(--text-2);
  font-size: 13.5px;
  font-weight: 500;
  transition: color 0.16s ease, background 0.16s ease;
}

.detail-tab:hover {
  color: var(--text-1);
  background: var(--bg-soft);
}

.detail-tab.is-active {
  color: var(--brand-dark);
  background: var(--brand-soft);
  font-weight: 600;
}

.detail-body {
  animation: none;
}

.detail-title {
  color: var(--text-1);
  font-size: 19px;
  font-weight: 700;
  margin-bottom: 14px;
}

.detail-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.detail-list li {
  position: relative;
  padding-left: 20px;
  color: var(--text-2);
  font-size: 14.5px;
  line-height: 1.7;
}

.detail-list li::before {
  content: "";
  position: absolute;
  top: 9px;
  left: 4px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--brand);
  opacity: 0.75;
}

.swap-enter-active,
.swap-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.swap-enter-from {
  opacity: 0;
  transform: translateY(8px);
}

.swap-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.detail-figure {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--r-lg);
  box-shadow: var(--shadow-sm);
  padding: 12px;
}

.detail-img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: var(--r-md);
  cursor: zoom-in;
  background: var(--bg-soft);
}

.detail-figure figcaption {
  margin-top: 10px;
  color: var(--text-3);
  font-size: 12.5px;
  text-align: center;
}

@media (max-width: 1024px) {
  .detail-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 768px) {
  .seg {
    width: 100%;
    margin-bottom: 24px;
  }
  .seg-item {
    flex: 1;
    justify-content: center;
    padding: 0 10px;
    font-size: 14px;
    height: 40px;
  }
  .shots {
    margin-bottom: 28px;
  }
  .shots :deep(.el-carousel__container) {
    height: 210px !important;
  }
  .detail-copy {
    padding: 20px;
  }
  .detail-title {
    font-size: 17px;
  }
  .detail-list li {
    font-size: 13.5px;
  }
}
</style>
